import {InvoiceLine} from './invoice-line';
import {BaseNumberModel} from '@shared/base/base-number-model';
import {Relation} from "@app/relation/shared/relation";

export class Invoice extends BaseNumberModel {
  id: number;
  uuid: string;
  administrationId: number;
  date: Date;
  referenceInternal: string;
  referenceExternal: string;
  referenceRelation: string;
  relationNumber: number;
  amount: number;
  payedAmount: number;
  payed: boolean;
  payedDate: Date;
  lineCount: number;
  credit: boolean;
  extraText: string;
  warrantyText: string;
  comment: string;
  lines: InvoiceLine[];
  relation: Relation;
  fileCount: number;
}
